import React, { useState, useEffect } from "react";
import { Clock, ShieldCheck, Zap, BadgeCheck } from "lucide-react";
import WafidPayDialog from "@/components/WafidPayDialog";

export default
function WafidPayCard({ link, expiresAt, onClose }) {
  const calcLeft = () => (expiresAt ? new Date(expiresAt).getTime() - Date.now() : Infinity);
  const [left, setLeft] = useState(calcLeft);
  useEffect(() => {
    if (!expiresAt) return;
    const t = setInterval(() => setLeft(calcLeft()), 1000);
    return () => clearInterval(t);
  }, [expiresAt]);
  if (left <= 0) return null;
  const pad = (n) => String(n).padStart(2, "0");
  const h = Math.floor(left / 3600000), m = Math.floor((left % 3600000) / 60000), s = Math.floor((left % 60000) / 1000);
  const urgent = left < 3 * 3600000;
  const showTimer = expiresAt && Number.isFinite(left);
  return (
    <div data-testid="track-wafid-pay-card"
      className="rounded-2xl border border-[#E9E4DB] bg-white shadow-sm px-5 py-6 sm:px-8 sm:py-7 text-center md:text-left">
      <div className="flex flex-col md:flex-row md:items-center gap-6">
        <div className="flex-1 min-w-0">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-green-50 border border-green-200 px-3 py-1 text-[11px] font-bold uppercase tracking-widest text-green-700">
            <BadgeCheck size={13} /> Slip Verified
          </span>
          <h3 className="font-heading text-[#1A1A1A] font-bold text-xl sm:text-2xl leading-snug mt-3">
            Your slip is ready — <span className="text-[#b1976b]">recover it now!</span>
          </h3>
          <p className="text-sm text-[#54595f] mt-1.5">One quick WAFID payment and your appointment slip is back in your hands — instantly.</p>
          {showTimer && (
            <div data-testid="wafid-expiry-timer" className={`mt-4 inline-flex flex-col sm:flex-row items-center gap-2 sm:gap-3 rounded-xl border px-4 py-2.5 ${urgent ? "bg-red-50 border-red-200" : "bg-[#FAF8F4] border-[#EDE8DF]"}`}>
              <span className={`flex items-center gap-1.5 text-[11px] font-bold uppercase tracking-wide ${urgent ? "text-red-600" : "text-[#54595f]"}`}>
                <Clock size={13} className={urgent ? "text-red-500" : "text-[#b1976b]"} /> Payment link expires in
              </span>
              <span className="flex items-center gap-1.5">
                {[[h, "hrs"], [m, "min"], [s, "sec"]].map(([v, l2], i) => (
                  <React.Fragment key={l2}>
                    {i > 0 && <span className={`text-base font-bold -mt-3 ${urgent ? "text-red-500" : "text-[#b1976b]"}`}>:</span>}
                    <span className="flex flex-col items-center">
                      <span className={`min-w-[40px] rounded-lg px-1.5 py-1 text-center text-base font-bold font-mono border ${urgent ? "bg-white text-red-600 border-red-300" : "bg-white text-[#1A1A1A] border-[#E5DFD3]"}`}>{pad(v)}</span>
                      <span className="text-[9px] uppercase tracking-wider text-[#9a9a9a] mt-1">{l2}</span>
                    </span>
                  </React.Fragment>
                ))}
              </span>
            </div>
          )}
        </div>
        <div className="flex flex-col items-stretch md:items-center gap-3 shrink-0 md:pl-2">
          <WafidPayDialog link={link} buttonTestId="track-pay-wafid-btn" onClose={onClose}
            buttonClassName="inline-flex w-full md:w-auto items-center justify-center gap-2 text-lg font-bold text-white bg-[#b1976b] hover:bg-[#9E855A] rounded-full px-10 py-4 transition-all duration-200 shadow-md hover:shadow-lg hover:-translate-y-0.5 active:scale-[0.98]" />
          <div className="flex items-center justify-center gap-3 text-[10px] text-[#8a8a8a]">
            <span className="flex items-center gap-1"><ShieldCheck size={12} className="text-green-600" /> 100% Secure</span>
            <span className="h-3 w-px bg-[#E5E1DA]" />
            <span className="flex items-center gap-1"><Zap size={12} className="text-[#b1976b]" /> Instant recovery</span>
          </div>
          <p className="text-center text-[10px] text-[#9a9a9a] -mt-1">Official payment via wafid.com</p>
        </div>
      </div>
    </div>
  );
}
